/* global dataLayer */

const Tracking = {

  init: () => {
    Tracking.$panels = $('#portfolio-images .panel');

    Tracking.initListeners();
  },

  initListeners: function() {

    $(document).on('click', '#portfolio-images .panel', Tracking.toggleProjectPanel);
  },

  toggleProjectPanel: function(e) {
    let $panel = $(e.currentTarget);

    if ( $panel.hasClass('active') ) {

        $panel.removeClass('active');

    } else {
      Tracking.$panels.removeClass('active');
      $panel.addClass('active');
      dataLayer.push({
        event: 'viewProject',
        eventCategory: 'Projects',
        eventAction: 'click',
        eventLabel: Tracking.makeUnquiePanelId($panel)
      });
    }
  },

  makeUnquiePanelId: function($panel) {
    let name = $panel.find('.details p').first().text();
    let imageParts = $panel.find('img').attr('src').split('/');
    let imageName = imageParts[imageParts.length -1 ];
    return `${name} - ${imageName}`;
  }

};

Tracking.init();



// WEBPACK FOOTER //
// ./src/_assets/js/modules/tracking.js